<template>
  <div class="user-center-container">
    <p class="title">设置</p>
    <section class="user-info">
      <section class="main-info">
        <el-upload
          accept="image/jpeg,image/jpg,image/png"
          action=""
          :show-file-list="false"
          :before-upload="handleBeforeUpload"
        >
          <div class="avatar-container">
            <el-image fit="cover" class="avatar" :src="headShow" />
            <div class="slogan">更换头像</div>
          </div>
        </el-upload>
        <!-- <p class="username">{{ userInfo.nickname }}</p> -->
        <div class="tag" v-if="userInfo.user_audit_avatar">审核中</div>
      </section>
      <ul class="info-list">
        <li class="info-item">
          <label class="label">用户名</label>
          <div class="info">
            <span>{{
              userInfo.user_audit_nickname
                ? userInfo.user_audit_nickname
                : userInfo.nickname
            }}</span>
            <div class="tag" v-if="userInfo.user_audit_nickname">审核中</div>
          </div>
          <span class="edit-btn" @click="handleEdit('nickname')">
            编辑
            <i class="el-icon-arrow-right" />
          </span>
        </li>
        <li class="info-item">
          <label class="label">简介</label>
          <div class="info">
            <span>{{
              userInfo.user_audit_description
                ? userInfo.user_audit_description
                : userInfo.description
            }}</span>
            <div class="tag" v-if="userInfo.user_audit_description">审核中</div>
          </div>
          <span class="edit-btn" @click="handleEdit('description')">
            编辑
            <i class="el-icon-arrow-right" />
          </span>
        </li>
        <li class="info-item">
          <label class="label">性别</label>
          <span class="info">{{ userInfo.sex | getSexName }}</span>
          <span class="edit-btn" @click="handleEdit('sex')">
            编辑
            <i class="el-icon-arrow-right" />
          </span>
        </li>
        <li class="info-item">
          <label class="label">生日</label>
          <span class="info">{{ userInfo.birthday }}</span>
          <span class="edit-btn" @click="handleEdit('birthday')">
            编辑
            <i class="el-icon-arrow-right" />
          </span>
        </li>

        <!-- todo: 现在没有密码登录 -->
        <!-- <li class="info-item">
          <label class="label">密码</label>
          <span class="info">******</span>
        </li> -->
      </ul>
    </section>
    <p class="title titletwo">账号信息</p>
    <section class="user-info" style="margin-top: 0">
      <ul class="info-list">
        <li class="info-item">
          <label class="label">手机号</label>
          <div class="info">
            <span>{{ userInfo.u_cellphone | phoneStar }}</span>
          </div>
          <span class="edit-btn" @click="handleEdit('editphone')">
            更换手机号
            <i class="el-icon-arrow-right" />
          </span>
        </li>
        <li class="info-item">
          <label class="label">登录密码</label>
          <div class="info">
            <span>******</span>
          </div>
          <span class="edit-btn" @click="handleEdit('password')">
            {{ userInfo.u_password == 1 ? "修改" : "设置" }}
            <i class="el-icon-arrow-right" />
          </span>
        </li>

        <!-- todo: 现在没有密码登录 -->
        <!-- <li class="info-item">
          <label class="label">密码</label>
          <span class="info">******</span>
        </li> -->
      </ul>
    </section>
    <el-dialog
      :visible="showEdit"
      width="462px"
      @close="cancelEdit"
      :title="editTitle"
    >
      <el-input
        type="text"
        show-word-limit
        maxlength="20"
        v-model="editValue"
        v-if="editType === 'nickname'"
      />
      <el-radio-group v-model="editValue" v-if="editType === 'sex'">
        <el-radio :label="1">男</el-radio>
        <el-radio :label="2">女</el-radio>
      </el-radio-group>
      <el-date-picker
        type="date"
        v-model="editValue"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        v-if="editType === 'birthday'"
      />
      <template v-if="editType === 'description'">
        <el-input
          type="textarea"
          show-word-limit
          maxlength="200"
          v-model="editValue"
        />
        <p class="sub-info">要求内容通顺，无特殊符号</p>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit">取 消</el-button>
        <el-button type="primary" @click="confirmEdit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible="showEditPhone"
      width="462px"
      title="手机号修改"
      @close="cancelEdit2"
    >
      <el-form size="small" label-width="120px" v-if="!sendSmsflag">
        <el-form-item label="原手机号">
          {{ userInfo.u_cellphone | phoneStar }}
        </el-form-item>
        <el-form-item label="输入验证码">
          <div class="yzinput">
            <el-input
              type="number"
              placeholder="请输入验证码"
              v-model="editform.captcha"
              autoComplete="new-password"
              oninput="if(value.length>6)value=value.slice(0,6)"
            ></el-input>
            <div class="btn">
              <el-button @click="sendsms">{{ regCodeText }}</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <el-form size="small" label-width="120px" v-if="sendSmsflag">
        <el-form-item label="新手机号">
          <el-input
            type="number"
            placeholder="请输入新手机号"
            v-model="editform.u_cellphone"
            oninput="if(value.length>11)value=value.slice(0,11)"
          ></el-input>
        </el-form-item>
        <el-form-item label="输入验证码">
          <div class="yzinput">
            <el-input
              type="number"
              placeholder="请输入验证码"
              v-model="editform.captcha2"
              autoComplete="new-password"
              oninput="if(value.length>6)value=value.slice(0,6)"
            ></el-input>
            <div class="btn">
              <el-button @click="sendsms2">{{ regCodeText }}</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit2">取 消</el-button>
        <el-button type="primary" @click="handleClickEditPhone">{{
          sendSmsflag ? "确定" : "下一步"
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="头像剪裁"
      :visible.sync="dialogVisible"
      class="thumbCutContainer"
      width="900px"
      :close-on-click-modal="false"
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedBox="option.fixedBox"
            :fixedNumber="option.fixedNumber"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改密码"
      :visible.sync="pwdVisible"
      class="pwdContainer"
      width="620px"
      :close-on-click-modal="false"
    >
      <div class="pwdContain">
        <div class="dd-editform" v-if="userInfo.u_password == 1">
          <el-form
            size="small"
            label-width="120px"
            :model="form"
            ref="form"
            label-position="left"
            :rules="formRules"
          >
            <el-form-item label="已绑定手机号">{{
              userInfo.u_cellphone | phoneStar
            }}</el-form-item>
            <el-form-item label="输入验证码" required prop="captcha">
              <div class="yzinput">
                <el-input
                  type="number"
                  placeholder="请输入验证码"
                  v-model="form.captcha"
                  autoComplete="new-password"
                  oninput="if(value.length>6)value=value.slice(0,6)"
                ></el-input>
                <div class="btn">
                  <el-button @click="sendsmsPwd">{{
                    regCodeTextPwd
                  }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="设置新密码" required prop="password">
              <el-input
                type="password"
                placeholder="请输入新密码"
                v-model="form.password"
                autoComplete="new-password"
                :show-password="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" required prop="againpassword">
              <el-input
                placeholder="再次输入密码"
                type="password"
                v-model="form.againpassword"
                autoComplete="new-password"
                :show-password="true"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="dd-editform" v-if="userInfo.u_password == 0">
          <el-form
            size="small"
            label-width="120px"
            :model="form2"
            ref="form2"
            label-position="left"
            :rules="formRules2"
          >
            <el-form-item label="设置新密码" required prop="password">
              <el-input
                type="password"
                placeholder="请输入新密码"
                v-model="form2.password"
                autoComplete="new-password"
                :show-password="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" required prop="againpassword">
              <el-input
                placeholder="再次输入密码"
                type="password"
                v-model="form2.againpassword"
                autoComplete="new-password"
                :show-password="true"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="userInfo.u_password == 1 ? editbtn : editbtn2"
          :loading="submiteditloading"
          @click="submitEditPassword"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  NEWS_HOST,
  USER_HOST,
  SWNEWS_HOST,
  COMMON_HOST,
} from "../../constants/apiHosts";
import { HS_upload } from "./../../utils/huoshanUpload";
import { VueCropper } from "vue-cropper";

export default {
  components: {
    VueCropper,
  },
  name: "userCenter",
  filters: {
    getSexName: function (sex) {
      return {
        1: "男",
        2: "女",
      }[sex];
    },
    phoneStar: function (phone) {
      if (phone) {
        return phone.replace(/^(1[34578]\d)(\d{4})(\d{4})$/, "$1 **** $3");
      } else {
        return "";
      }
    },
  },
  computed: {
    editTitle: function () {
      const titleMap = {
        nickname: "编辑用户名",
        sex: "编辑性别",
        birthday: "编辑生日",
        description: "编辑用户简介",
      };
      return titleMap[this.editType];
    },
    editbtn() {
      if (this.form.captcha && this.form.password && this.form.againpassword) {
        return false;
      } else {
        return true;
      }
    },
    editbtn2() {
      if (this.form2.password && this.form2.againpassword) {
        return false;
      } else {
        return true;
      }
    },
  },
  data: function () {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form2.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      showEdit: false,
      editType: "",
      editValue: "",
      userInfo: {
        username: "",
        description: "",
        sex: -1,
        birthday: "",
      },
      headShow: "",
      fileLoading: null,
      showEditPhone: false,
      sendSmsflag: false,
      regCodeText: "发送验证码",
      regCodeTime: 60,
      time: null,
      editform: {
        captcha: "",
        u_cellphone: "",
        captcha2: "",
      },
      dialogVisible: false,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 900, // 默认生成截图框宽度
        autoCropHeight: 500, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true,
        height: false, //是否按照设备的dpr 输出等比例图片
        enlarge: 2, //图片根据截图框输出比例倍数
      },
      pwdVisible: false,
      regCodeTextPwd: "发送验证码",
      regCodeTimePwd: 60,
      form: {
        captcha: "",
        password: "",
        againpassword: "",
      },
      form2: {
        password: "",
        againpassword: "",
      },
      submiteditloading: false,
      formRules: {
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        againpassword: [
          { required: true, message: "再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      formRules2: {
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        againpassword: [
          { required: true, message: "再次输入密码", trigger: "blur" },
          { validator: validatePass3, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    // 发送2
    async sendsms2() {
      if (!this.editform.u_cellphone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.regCodeTime != 60) return;
      try {
        const { data } = await this.$axios.post(
          `${COMMON_HOST}/user/sms/send`,
          {
            u_cellphone: this.editform.u_cellphone,
            captchaType: "common",
          }
        );
        if (data.code == 0) {
          this.$message({
            type: "success",
            message: "发送成功!",
          });
        } else {
          this.$message({
            type: "error",
            message: data.msg,
          });
          return;
        }
        this.regCodeText = `重新获取（${this.regCodeTime}）`;
        this.time = setInterval(() => {
          if (this.regCodeTime > 0) {
            this.regCodeTime--;
            this.regCodeText = `重新获取（${this.regCodeTime}）`;
          } else {
            this.regCodeText = `重新获取`;
            this.regCodeTime = 60;
            clearInterval(t);
          }
        }, 1000);
      } catch {}
    },
    // 发送验证码
    async sendsms() {
      if (this.regCodeTime != 60) return;
      try {
        const { data } = await this.$axios.post(
          `${COMMON_HOST}/user/sms/send`,
          {
            u_cellphone: this.userInfo.u_cellphone,
            captchaType: "common",
          }
        );
        if (data.code == 0) {
          this.$message({
            type: "success",
            message: "发送成功!",
          });
          this.regCodeText = `重新获取（${this.regCodeTime}）`;
          this.time = setInterval(() => {
            if (this.regCodeTime > 0) {
              this.regCodeTime--;
              this.regCodeText = `重新获取（${this.regCodeTime}）`;
            } else {
              this.regCodeText = `重新获取`;
              this.regCodeTime = 60;
              clearInterval(t);
            }
          }, 1000);
        } else {
          this.$message({
            type: "error",
            message: data.msg,
          });
        }
      } catch {}
    },
    // 修改手机号
    async handleClickEditPhone() {
      if (!this.sendSmsflag) {
        if (!this.editform.captcha) {
          this.$message.error("请输入验证码");
        } else {
          try {
            const { data } = await this.$axios(
              `${USER_HOST}/user/sms/verifyCaptcha`,
              {
                method: "post",
                data: {
                  u_cellphone: this.userInfo.u_cellphone,
                  captcha: this.editform.captcha,
                },
              }
            );
            if (data.code !== 0) {
              this.$message.error(data.msg);
              return false;
            }
            this.sendSmsflag = true;
            if (this.time) {
              clearInterval(this.time);
              this.regCodeText = `发送验证码`;
              this.regCodeTime = 60;
            }
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        if (!this.editform.captcha2) {
          this.$message.error("请输入验证码");
          return;
        }
        if (!this.editform.u_cellphone) {
          this.$message.error("请输入手机号");
          return;
        }
        try {
          const { data } = await this.$axios(
            `${USER_HOST}/user/user/cellPhoneChange`,
            {
              method: "post",
              data: {
                old_u_cellphone: this.userInfo.u_cellphone,
                u_cellphone: this.editform.u_cellphone,
                captcha: this.editform.captcha2,
              },
            }
          );
          if (data.code !== 0) {
            this.$message.error(data.msg);
            return false;
          }
          this.$message.success("修改成功");
          this.getUserInfo();
          this.cancelEdit2();
        } catch (e) {
          console.log(e);
        }
      }
    },
    cancelEdit2() {
      this.editform = {
        captcha: "",
        u_cellphone: "",
        captcha2: "",
      };
      this.sendSmsflag = false;
      this.showEditPhone = false;
    },
    // 取消编辑
    cancelEdit: function () {
      this.showEdit = false;
    },
    confirmEdit: async function () {
      try {
        const { data } = await this.$axios(`${NEWS_HOST}/api/user/edit`, {
          method: "post",
          data: this.setEditData(),
        });
        if (data.code !== 0) {
          this.$message.error(data.msg);
          return false;
        } else {
          this.$message({
            type: "success",
            message: "提交成功!",
          });
        }
        this.cancelEdit();

        let editObj = this.setEditData();
        if (editObj.u_avatar) {
          this.headShow = editObj.u_avatar;
          this.userInfo.user_audit_avatar = editObj.u_avatar;
        } else if (editObj.u_nickname) {
          this.userInfo.user_audit_nickname = editObj.u_nickname;
        } else if (editObj.u_description) {
          this.userInfo.user_audit_description = editObj.u_description;
        } else if (editObj.u_sex) {
          this.userInfo.sex = editObj.u_sex;
        } else if (editObj.u_birthday) {
          this.userInfo.birthday = editObj.u_birthday;
        } else {
          setTimeout(async () => {
            await this.getUserInfo();
          }, 1000);
        }
      } catch (e) {
        console.log(e);
      }
    },
    setEditData: function () {
      let postData = {};
      postData[`u_${this.editType}`] = this.editValue;
      return postData;
    },
    /**
     * 编辑处理回调
     * @param type 编辑的类型
     */
    handleEdit: function (type) {
      if (type == "password") {
        this.pwdVisible = true;
        return;
      }
      if (type == "editphone") {
        this.showEditPhone = true;
        return;
      }
      if (type == "nickname" && this.userInfo.user_audit_nickname) {
        this.$message.error("当前信息正在审核");
        return;
      }
      if (type == "description" && this.userInfo.user_audit_description) {
        this.$message.error("当前信息正在审核");
        return;
      }
      this.editType = type;
      this.showEdit = true;
      this.editValue = this.userInfo[type];
    },
    /**
     * 映射字段key ，方便用于编辑的时候取值
     * @param item
     * @return {{birthday: *, sex: *, description: *, username: (string|*)}}
     */
    mapApiData: function (item = {}) {
      return {
        nickname: item.u_nickname,
        sex: item.u_sex,
        birthday: item.u_birthday,
        description: item.u_description,
        ...item,
      };
    },
    // 获取用户信息
    getUserInfo: async function () {
      const { data } = await this.$axios(
        `${SWNEWS_HOST}/api/user/mpBaseUserinfo`,
        {
          method: "get",
        }
      );
      this.headShow = data.data.user_audit_avatar
        ? data.data.user_audit_avatar
        : data.data.u_avatar;
      this.userInfo = this.mapApiData(data.data);
      // 更新全局用户信息状态
      this.$store.commit("common/setUserInfo", {
        u_nickname: data.data.u_nickname,
        u_avatar: data.data.u_avatar,
      });
    },
    /**
     * 上传文件前钩子，返回false则终止上传
     * @param event 数据格式详见el-upload文档
     * @return boolean
     */
    handleBeforeUpload: function (event) {
      if (this.userInfo.user_audit_avatar) {
        this.$message.error("当前信息正在审核");
        return false;
      }
      this.fileLoading = this.$loading({
        text: "上传中",
      });
      HS_upload(
        event,
        async (data) => {
          this.fileLoading.close();
          this.dialogVisible = true;

          this.option.img = data.url;
          if (this.$refs.cropper) {
            this.$refs.cropper.reload();
          }
        },
        (error) => {
          console.log("error:" + error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        let file = new window.File([data], "1.jpg", { type: "image/jpeg" });
        HS_upload(
          file,
          async (data) => {
            this.editType = "avatar";
            this.editValue = data.url;
            await this.confirmEdit();
            this.dialogVisible = false;
          },
          (error) => {
            console.log("error:" + error);
          },
          (processPercent) => {
            console.log("processPercent:" + processPercent);
          }
        );
      });
    },
    // 确定修改密码
    submitEditPassword() {
      if (this.userInfo.u_password == 0) {
        this.submitEditPassword2();
        return;
      }

      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let form = {
            captcha: this.form.captcha,
            password: this.form.password,
            u_cellphone: this.userInfo.u_cellphone,
          };
          try {
            const { data } = await this.$axios.post(
              `${USER_HOST}/user/user/pwdUpdate`,
              { ...form }
            );
            if (data.code == 0) {
              this.$message.success("修改成功");
              this.pwdVisible = false;
            } else {
              this.$message.error(data.msg);
            }
          } catch {}
        } else {
          return false;
        }
      });
    },
    submitEditPassword2() {
      this.$refs.form2.validate(async (valid) => {
        if (valid) {
          let form = {
            password: this.form2.password,
            again_password: this.form2.againpassword,
          };
          try {
            const { data } = await this.$axios.post(
              `${USER_HOST}/user/user/pwdSet`,
              { ...form }
            );
            if (data.code == 0) {
              this.$message.success("设置成功");
              this.pwdVisible = false;
            } else {
              this.$message.error(data.msg);
            }
          } catch {}
        } else {
          return false;
        }
      });
    },
    // 发送验证码
    async sendsmsPwd() {
      if (this.regCodeTimePwd != 60) return;
      try {
        const { data } = await this.$axios.post(
          `${COMMON_HOST}/user/sms/send`,
          {
            u_cellphone: this.userInfo.u_cellphone,
            captchaType: "common",
          }
        );
        if (data.code == 0) {
          this.$message({
            type: "success",
            message: "发送成功!",
          });
          this.regCodeTextPwd = `重新获取（${this.regCodeTimePwd}）`;
          let t = setInterval(() => {
            if (this.regCodeTimePwd > 0) {
              this.regCodeTimePwd--;
              this.regCodeTextPwd = `重新获取（${this.regCodeTimePwd}）`;
            } else {
              this.regCodeTextPwd = `重新获取`;
              this.regCodeTimePwd = 60;
              clearInterval(t);
            }
          }, 1000);
        } else {
          this.$message({
            type: "error",
            message: data.msg,
          });
        }
      } catch {}
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
.user-center-container {
  background: #fff;
  padding-bottom: 67px;

  .title {
    color: #333333;
    font-family: "PingFang SC";
    font-size: 18px;
    font-weight: 500;
    line-height: 69px;
    padding-left: 24px;
    border-bottom: 1px solid #eeeeee;
  }

  .titletwo {
    margin-top: 38px;
    border-bottom: 0;
    padding-left: 40px;
  }

  .user-info {
    margin-top: 27px;
    padding: 0 42px;

    .main-info {
      display: flex;
      align-items: center;

      .avatar-container {
        width: 100px;
        height: 100px;
        border-radius: 50px;
        overflow: hidden;
        background: $img-bg-color;
        position: relative;

        .avatar {
          width: 100%;
          height: 100%;
        }
        .slogan {
          width: 100%;
          height: 27px;
          position: absolute;
          bottom: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.5);
          text-align: center;
          line-height: 27px;
          font-size: 10px;
          color: #fff;
        }
      }
      .username {
        font-weight: 800;
        font-size: 22px;
        color: $text-color-main;
        margin-left: 20px;
      }
    }

    .info-list {
      .info-item {
        padding: 24px 0;
        display: flex;
        border-bottom: 1px solid #eeeeee;
        font-size: 16px;
        align-items: center;

        .label {
          width: 120px;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
        }

        .info {
          flex: 1;
          color: #666666;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          padding-right: 200px;
          display: flex;
          align-items: center;
        }

        .edit-btn {
          font-size: 16px;
          color: #5574e7;
          cursor: pointer;

          .el-icon-arrow-right {
            font-weight: bolder;
            color: #999;
          }
        }
      }
    }
  }

  .sub-info {
    color: #999999;
    margin-top: 10px;
  }
}
.tag {
  padding: 5px 12px;
  background-color: #fff1e5;
  color: #ff7600;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  flex-shrink: 0;
}

.yzinput {
  display: flex;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}

/deep/.el-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -65%);
  margin: 0 !important;

  .el-dialog__header {
    padding-bottom: 24px;

    .el-dialog__title {
      color: #333333;
      font-family: "PingFang SC";
      font-size: 16px;
      font-weight: 400;
    }
  }

  .el-dialog__body {
    padding-top: 0;

    .el-input {
      margin: 0;
    }

    .el-textarea__inner {
      min-height: 150px !important;
    }

    .el-date-editor {
      width: 100%;
    }

    .el-form-item {
      &:last-child {
        margin-bottom: 0;
      }

      .el-form-item__label {
        width: 106px !important;
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
      }

      .el-form-item__content {
        margin-left: 106px !important;
      }
    }

    input {
      margin: 0;
    }

    .el-input__inner {
      height: 34px;
    }

    .btn {
      margin-left: 10px;
    }
  }

  .el-dialog__footer {
    padding-top: 6px;
  }
}

/deep/.thumbCutContainer {
  .el-dialog {
    transform: translate(-50%, -54%);
  }

  .el-dialog__body {
    padding-bottom: 10px;
    padding-top: 0;

    .avatar-uploader {
      background: red !important;
      width: 150px;
      height: 150px;
      text-align: center;
      line-height: 150px;
    }

    .el-icon-plus {
      width: 150px;
      height: 150px;
      font-size: 30px;
    }

    .cropper-content {
      width: 100%;
      height: 500px;
      background: pink;
    }

    .cropper {
      width: 100%;
      height: 500px;
      background: yellow;
    }

    .cropper-modal {
      background: rgba(0, 0, 0, 0.2) !important;
    }

    .cropper-view-box {
      img {
        display: none;
      }
    }
  }
}
</style>
